import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import dataManagementEsCL from './locales/es-CL.json';
import dataManagementEnUS from './locales/en-US.json';
import dataManagementPtBR from './locales/pt-BR.json';

export const dataManagementI18n = buildScopedI18n({
  esCL: dataManagementEsCL,
  enUS: dataManagementEnUS,
  ptBR: dataManagementPtBR,
});
